import React from 'react';
import {
  createStyles,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  WithStyles,
  withStyles
} from '@material-ui/core';
import {InvertColorsOutlined} from '@material-ui/icons';

import {Theme} from '../../contexts/theme';

interface State {
  menu?: any;
}

const styles = () =>
  createStyles({
    white: {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white'
      }
    },
    black: {
      backgroundColor: '#303030',
      '&:hover': {
        backgroundColor: '#303030'
      }
    },
    blue: {
      backgroundColor: '#327db0',
      '&:hover': {
        backgroundColor: '#327db0'
      }
    }
  });

class MainTheme extends React.Component<WithStyles<typeof styles>, State> {
  state = {
    menu: undefined
  };

  /**
   * Открыть меню
   * @param event
   */
  openMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({menu: event.currentTarget});
  };

  /**
   * Закрыть меню
   */
  closeMenu = () => {
    this.setState({menu: undefined});
  };

  render() {
    const {menu} = this.state;
    const {classes} = this.props;

    return (
      <Theme.Consumer>
        {({changeTheme}) => (
          <React.Fragment>
            <IconButton color='inherit' onClick={this.openMenu}>
              <InvertColorsOutlined />
            </IconButton>
            <Menu
              anchorEl={menu}
              open={Boolean(menu)}
              onClose={this.closeMenu}
              onClick={this.closeMenu}
              getContentAnchorEl={null}
              anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
              transformOrigin={{vertical: 'top', horizontal: 'center'}}
            >
              <MenuItem onClick={() => changeTheme('white')}>
                <Fab className={classes.white} variant='extended' size='small'>
                  &nbsp;
                </Fab>
              </MenuItem>
              <MenuItem onClick={() => changeTheme('black')}>
                <Fab className={classes.black} variant='extended' size='small'>
                  &nbsp;
                </Fab>
              </MenuItem>
              <MenuItem onClick={() => changeTheme('blue')}>
                <Fab className={classes.blue} variant='extended' size='small'>
                  &nbsp;
                </Fab>
              </MenuItem>
            </Menu>
          </React.Fragment>
        )}
      </Theme.Consumer>
    );
  }
}

export default withStyles(styles, {name: 'MainTheme'})(MainTheme);
